import { executeGraphQlQuery } from '../helpers/storefront-graphql-helper'

const normalizeGqlProductFields = () => `
  title
  id
  handle
  onlineStoreUrl
  featuredImage {
    altText
    url
  }
  images(first: 10) {
    nodes {
      url
      altText
    }
  }
  variants(first: 50) {
    nodes {
      price {
        amount
      }
      compareAtPrice {
        amount
      }
    }
  }
  tags
  metafield(namespace: "product_details", key: "size") {
    value
    namespace
    key
  }
`

const getGraphQLID = (id, type) => `gid://shopify/${type}/${id}`

const getGraphQLIds = (ids, type) => {
  if (ids.length === 0) return []

  return ids.map((id) => getGraphQLID(id, type))
}

const buildCollectionsQuery = (handle, filters, size) => {
  const variables = {
    handle,
    filters,
    first: size
  }

  const query = `
  query Collection($handle: String, $first: Int, $filters: [ProductFilter!]) {
    collection(handle: $handle) {
      products(first: $first, filters: $filters) {
        nodes {
          ${normalizeGqlProductFields()}
        }
      }
    }
  }
  `
  return {
    query,
    variables
  }
}

const fetchProductByCollectionHandle = async (handle, filters = [], size = 10) => {
  const gqlQuery = buildCollectionsQuery(handle, filters, size)
  const products = executeGraphQlQuery(gqlQuery)
    .then((res) => {
      if (!res.ok) throw res
      return res.json()
    }).then((body) => body.data.collection.products.nodes)
  return products
}

export {
  fetchProductByCollectionHandle,
  getGraphQLIds,
  normalizeGqlProductFields
}
